import { useSelector } from '@xstate/react';
import type { EventObject, MachineContext } from 'xstate';

import type { MachineState } from '../../../../interfaces/machines';
import { getFlow } from '../../helpers/flow/getFlow';
import { Events } from '../../machine/types';
import { Context } from '../../machine/types/Context';

interface OnboardingAuthenticationProps<C extends MachineContext, E extends EventObject> {
  onboardingState: MachineState<C, E>;
}

export const OnboardingAuthentication = <C extends MachineContext, E extends EventObject>({
  onboardingState,
}: OnboardingAuthenticationProps<C, E>) => {
  const { authenticationService } = onboardingState.children;
  const currentState = useSelector(authenticationService, state => state) as MachineState<
    Context,
    Events
  >;
  const stateName = currentState.value.toString();
  const Flow = getFlow(stateName);

  return <>{Flow && <Flow authenticationState={currentState} />}</>;
};
